import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RankingComponent } from './ranking.component';
import { SharedComponentsModule } from '.././../shared-components/shared-components.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule
  ],
  exports: [
    RankingComponent
  ],
  declarations: [
    RankingComponent
  ]
})
export class RankingModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/ranking/ranking.module.ts